import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Input from '@mui/material/Input';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Header from '../components/Header';
import BottomNav from '../components/BottomNav';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Footer from "../components/Footer";
import { loadTossPayments } from '@tosspayments/payment-sdk'
import { useAuth } from '../contexts/AuthContext';
import constraints from '../constraints';

export default function PurchaseTab({ navigation }) {
  const { currentUser, getSubscriptionStatus } = useAuth();
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [autoRenewCheckbox, setAutoRenewCheckbox] = useState(false);

  useEffect(() => {
    async function init() {
      const {
        isRegisteredCard,
        isSubscriptionActivated
      } = await getSubscriptionStatus();

      if (!isRegisteredCard) {
        setSubscriptionStatus("NOT_REGISTERED_CARD");
      }

      if (isRegisteredCard && !isSubscriptionActivated) {
        setAutoRenewCheckbox(false);
        setSubscriptionStatus("NOT_SUBSCRIBED");
      }

      if (isRegisteredCard && isSubscriptionActivated) {
        setAutoRenewCheckbox(true);
        setSubscriptionStatus("SUBSCRIBED");
      }
    }

    init();
  }, []);

  const _createUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
      return v.toString(16);
    });
  }

  const onClickPurchase = async (price) => {
    if (true) {
      loadTossPayments(constraints.config.TOSS_CLIENT_KEY).then(tossPayments => {
        tossPayments.requestPayment('카드', { // 결제 수단 파라미터
          // 결제 정보 파라미터
          amount: price,
          orderId: _createUUID(),
          orderName: `그림그리기 1년`,
          // customerName: '박토스',
          successUrl: constraints.config.TOSS_PAYMENT_DIRECT_PURCHASE_SUCCESS_CALLBACK_URL,
          failUrl: constraints.config.TOSS_PAYMENT_DIRECT_PURCHASE_FAIL_CALLBACK_URL,
        });
      });
    }
  }

  const autoPaymentCheckboxChange = ({ target }) => {
    setAutoRenewCheckbox(target.checked);
  }

  const renderPaymentUIV2 = () => {
    // 
    if (true) {
      return (
        <div>
          <p>
            무제한 그림 그리기권을 구매해서 구입후 1년동안 그림을 무제한으로 그릴 수 있습니다.
          </p>

          <div onClick={ () => onClickPurchase(10000) } className="bg-neutral-600 p-4 mb-5 mt-5 cursor-pointer rounded-md">
            <p className="text-white">1년 무제한 그림 그리기권 (10000원)</p>
          </div>

          {/* <div onClick={ () => onClickPurchase(25000) } className="bg-neutral-600 p-4 mb-5 mt-5 cursor-pointer rounded-md">
            <p className="text-white">300 크레딧 구매 -> (25000원)</p>
          </div> */}
        </div>
      );
    }

    if (subscriptionStatus == "NOT_SUBSCRIBED" || subscriptionStatus == "SUBSCRIBED") {
      return (
        <div>
          <p className="text-base">구독이 완료되었습니다!</p>
          <p className="text-base">구독을 활성화하거나 해지하려면</p>
          <p className="text-base">체크박스를 변경후 확인하세요</p>
          <div class="flex items-center mb-4 mt-5">
            <input onChange={(e) => autoPaymentCheckboxChange(e)} id="default-checkbox" type="checkbox" checked={autoRenewCheckbox ? "checked" : ""} class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
            <label for="default-checkbox" class="ml-2 text-sm font-medium text-gray-900">정기결제 활성화 여부 </label>
          </div>

          <div onClick={ () => alert("반영이 완료되었습니다!") } className="p-4 mb-5 cursor-pointer bg-lime-600 rounded-md justify-center items-center flex">
            <p className="text-white">반영하기</p>
          </div>
        </div>
      );
    }
  }

  const renderPaymentUI = () => {
    // 
    if (subscriptionStatus == "NOT_REGISTERED_CARD") {
      return (
        <div>
          <p>
            그림그리기 상품을 구독하면 월 무제한으로 그림생성이 가능합니다!
          </p>

          <div onClick={onClickPurchase} className="bg-neutral-600 p-4 mb-5 mt-5 cursor-pointer rounded-md">
            <p className="text-white">구독 1개월 (30일) => 20000원</p>
          </div>
        </div>
      );
    }

    if (subscriptionStatus == "NOT_SUBSCRIBED" || subscriptionStatus == "SUBSCRIBED") {
      return (
        <div>
          <p className="text-base">구독이 완료되었습니다!</p>
          <p className="text-base">구독을 활성화하거나 해지하려면</p>
          <p className="text-base">체크박스를 변경후 확인하세요</p>
          <div class="flex items-center mb-4 mt-5">
            <input onChange={(e) => autoPaymentCheckboxChange(e)} id="default-checkbox" type="checkbox" checked={autoRenewCheckbox ? "checked" : ""} class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
            <label for="default-checkbox" class="ml-2 text-sm font-medium text-gray-900">정기결제 활성화 여부 </label>
          </div>

          <div onClick={ () => alert("반영이 완료되었습니다!") } className="p-4 mb-5 cursor-pointer bg-lime-600 rounded-md justify-center items-center flex">
            <p className="text-white">반영하기</p>
          </div>
        </div>
      );
    }
  }

  return (
    <div className="w-full h-screen  pb-40">
      <Header />

      <div className="flex flex-col h-full ">
        
        <div className="flex flex-col p-5">
          <h1 className="text-2xl mb-5">결제 상품</h1>
          {renderPaymentUIV2()}

          <div className="rounded-xl bg-zinc-200">
            <div className="flex flex-col p-4">
               <p className="font-bold mb-3">환불정책</p>

              <p className="mb-5 text-xs">
                1. 회원은 회사에 환불을 요구할 수 있습니다. 환불은 회사가 안내하는 정책 및 방법에 따라 진행됩니다.
              </p>

              <p className="font-bold text-xs">
                2. 회사는 다음 각 호의 방식으로 환불을 진행합니다.
              </p>

              <p className="text-xs">
                * 1년 그림 그리기권은 구매후 한번이라도 사용한 경우 환불이 불가능합니다.
              </p>

              <p className="text-xs">
                * 1년 그림 그리기권을 구매하고 사용하지 않은 상태에서 30일 이내에 환불을 요청하면 구매 금액의 100%를 환불해 드립니다.
              </p>

              {/* <p className="text-xs">
               * 결제 당시 서비스 재화 가치로 측정해서 환불이 진행됩니다.
              </p> */}
              {/* <p className="font-bold mb-3">환불정책</p>

              <p className="mb-5 text-xs">
                1. 회원은 회사에 환불을 요구할 수 있습니다. 환불은 회사가 안내하는 정책 및 방법에 따라 진행됩니다.
              </p>

              <p className="font-bold text-xs">
                2. 회사는 다음 각 호의 방식으로 환불을 진행합니다.
              </p>

              <p className="text-xs">
                * 한달 구독의 경우, 구독이 시작된 시간으로 부터 이미지 생성을 하지 않았다면 환불 요청에 대해 환불을 진행합니다.
              </p>

              <p className="text-xs">
               * 서비스 공급 후 사용에 따른 가치 감소 등으로 재 판매가 불가한 경우는 제외됩니다.
              </p>

              <p className="text-xs">
                * 그러나 구독을 시작하고, 서비스를 이용한 경우 환불을 진행하지 않습니다.
              </p> */}
            </div>
          </div>
        </div>

        

        <div className="flex flex-1">

        </div>

        <div className="flex flex-col w-full h-40 p-5 m-2" style={{ backgroundColor: '#F6F6F6'}}>

          <div className="flex flex-row mb-1">
            <div className="flex w-2/6 ">
              <p style={{ color: '#646464', fontSize: 13 }}>대표자</p>
            </div>

            <div className="flex flex-1 ">
              <p className="text-sm text-center" style={{ color: '#A1A1A1', fontSize: 13 }}>강순정</p>
            </div>
          </div>

          <div className="flex flex-row mb-1">
            <div className="flex w-2/6 ">
              <p style={{ color: '#646464', fontSize: 13 }}>상호명</p>
            </div>

            <div className="flex flex-1 ">
              <p className="text-sm text-center" style={{ color: '#A1A1A1', fontSize: 13 }}>노우알</p>
            </div>
          </div>

          <div className="flex flex-row mb-1">
            <div className="flex w-2/6 ">
              <p className="text-sm" style={{ color: '#646464', fontSize: 13 }}>사업자등록번호</p>
            </div>

            <div className="flex flex-1 ">
              <p className="text-sm text-center" style={{ color: '#A1A1A1', fontSize: 13 }}>261-27-00941</p>
            </div>
          </div>

          <div className="flex flex-row mb-1">
            <div className="flex w-2/6 ">
              <p className="text-sm" style={{ color: '#646464', fontSize: 13 }}>주소</p>
            </div>

            <div className="flex flex-1 ">
              <p className="text-sm text-center" style={{ color: '#A1A1A1', fontSize: 13 }}>충청남도 서천군 서천읍 사곡로75번길 6</p>
            </div>
          </div>

          <div className="flex flex-row mb-1">
            <div className="flex w-2/6 ">
              <p className="text-sm" style={{ color: '#646464', fontSize: 13 }}>통신판매업</p>
            </div>

            <div className="flex flex-1 ">
              <p className="text-sm text-center" style={{ color: '#A1A1A1', fontSize: 13 }}>제 2022 충남서천 0107호</p>
            </div>
          </div>

          <div className="flex flex-row mb-1">
            <div className="flex w-2/6 ">
              <p className="text-sm" style={{ color: '#646464', fontSize: 13 }}>고객센터</p>
            </div>

            <div className="flex flex-1 ">
              <p className="text-sm text-center" style={{ color: '#A1A1A1', fontSize: 13 }}>041-953-3579</p>
            </div>
          </div>

        </div>
  
      </div>
      
      <BottomNav />

    </div>
  )
}